<template>
    <div class="min-h-screen p-6 bg-background">
        <div class="max-w-6xl mx-auto space-y-6">
            <header class="flex items-center justify-between gap-4">
                <h1 class="text-3xl font-serif">Mon classement</h1>
                <div class="flex items-center gap-3 flex-wrap justify-end">
                    <router-link :to="{ name: 'BuyRanking' }">
                        <button class="btn-gold">Monter maintenant</button>
                    </router-link>
                    <button class="btn-accent" @click="refresh">Rafraîchir</button>
                    <button class="btn-gold" @click="$emit('openHelp')">Aide</button>
                </div>
            </header>

            <section class="card-gold-premium p-5 space-y-4">
                <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                    <div>
                        <h2 class="text-lg font-semibold text-gold">Accélérez votre progression</h2>
                        <p class="text-sm text-secondary mt-1">
                            {{ rankingPitch }}
                        </p>
                        <p v-if="suggestedCallout" class="text-sm text-gold font-semibold mt-2">
                            {{ suggestedCallout }}
                        </p>
                    </div>
                    <router-link :to="buyRankingLink"
                        class="inline-flex items-center justify-center rounded-lg bg-gold px-4 py-2 text-sm font-semibold text-primary hover:opacity-90 transition self-start md:self-center">
                        Passer au paiement
                    </router-link>
                </div>

                <div class="flex flex-wrap gap-2">
                    <button v-for="preset in quickAmounts" :key="preset" type="button"
                        class="rounded-full border border-gold/30 px-3 py-1 text-sm text-gold hover:bg-gold hover:text-primary transition"
                        @click="sim.amount = preset">
                        Simuler {{ preset }}€
                    </button>
                </div>
            </section>

            <!-- SUMMARY CARDS -->
            <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                <!-- Général -->
                <div class="card-primary">
                    <h3 class="text-sm uppercase text-secondary">Classement général</h3>
                    <p v-if="ranks.general" class="text-2xl font-semibold mt-2">#{{ ranks.general.position }}</p>
                    <p v-else class="text-2xl font-semibold mt-2 text-secondary">Non classé</p>

                    <p v-if="ranks.general" class="text-sm text-secondary mt-1">
                        Sur {{ ranks.general.total }} utilisateurs
                    </p>
                    <p v-else class="text-xs text-secondary mt-1">
                        Impossible de calculer votre classement général.
                    </p>
                </div>

                <!-- Régional -->
                <div class="card-primary">
                    <h3 class="text-sm uppercase text-secondary">Classement régional</h3>

                    <p v-if="ranks.regional" class="text-2xl font-semibold mt-2">
                        #{{ ranks.regional.position }}
                    </p>
                    <p v-else class="text-2xl font-semibold mt-2 text-secondary">Non classé</p>

                    <p v-if="ranks.regional" class="text-sm text-secondary mt-1">
                        {{ ranks.regional.regionName }} — {{ ranks.regional.total }} utilisateurs
                    </p>
                    <p v-else class="text-xs text-secondary mt-1">
                        Renseignez votre région dans <router-link :to="{ name: 'UserAccount' }"><span
                                class="underline">Mon compte</span></router-link>.
                    </p>
                </div>

                <!-- Départemental -->
                <div class="card-primary">
                    <h3 class="text-sm uppercase text-secondary">Classement départemental</h3>

                    <p v-if="ranks.departmental" class="text-2xl font-semibold mt-2">
                        #{{ ranks.departmental.position }}
                    </p>
                    <p v-else class="text-2xl font-semibold mt-2 text-secondary">Non classé</p>

                    <p v-if="ranks.departmental" class="text-sm text-secondary mt-1">
                        {{ ranks.departmental.departmentName }} — {{ ranks.departmental.total }} utilisateurs
                    </p>
                    <p v-else class="text-xs text-secondary mt-1">
                        Renseignez votre département dans <router-link :to="{ name: 'UserAccount' }"><span
                                class="underline">Mon compte</span></router-link>.
                    </p>
                </div>

                <!-- Communal -->
                <div class="card-primary">
                    <h3 class="text-sm uppercase text-secondary">Classement communal</h3>

                    <p v-if="ranks.city" class="text-2xl font-semibold mt-2">
                        #{{ ranks.city.position }}
                    </p>
                    <p v-else class="text-2xl font-semibold mt-2 text-secondary">Non classé</p>

                    <p v-if="ranks.city" class="text-sm text-secondary mt-1">
                        {{ ranks.city.cityName }} — {{ ranks.city.total }} utilisateurs
                    </p>
                    <p v-else class="text-xs text-secondary mt-1">
                        Renseignez votre commune dans <router-link :to="{ name: 'UserAccount' }"><span
                                class="underline">Mon compte</span></router-link>.
                    </p>
                </div>
            </section>

            <!-- Detailed rankings -->
            <!--<section class="card-primary">
                <div class="flex items-center justify-between mb-4">
                    <h2 class="text-xl font-semibold">Détails des classements</h2>
                    <div class="flex items-center gap-2">
                        <label class="text-sm text-secondary">Filtrer :</label>
                        <select v-model="selectedScope" class="px-3 py-2 rounded-lg border">
                            <option value="general">Général</option>
                            <option value="regional" :disabled="!ranks.regional">Régional</option>
                            <option value="departmental" :disabled="!ranks.departmental">Départemental</option>
                            <option value="city" :disabled="!ranks.city">Communal</option>
                        </select>
                    </div>
                </div>

                <table class="w-full table-auto">
                    <thead>
                        <tr class="text-left text-sm text-secondary border-b">
                            <th class="py-2">Position</th>
                            <th>Utilisateur</th>
                            <th>Score (€)</th>
                            <th>Diff</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in listForSelectedScope" :key="item.id" class="border-b">
                            <td class="py-3">#{{ item.position }}</td>
                            <td class="py-3">{{ item.name }}</td>
                            <td class="py-3 font-mono">{{ formatNumber(item.score) }}</td>
                            <td class="py-3 text-sm text-secondary">{{ item.deltaText || '-' }}</td>
                            <td class="py-3 text-right">
                                <button class="btn-primary text-sm" @click="viewProfile(item)">Voir</button>
                            </td>
                        </tr>
                        <tr v-if="listForSelectedScope.length === 0">
                            <td colspan="5" class="py-6 text-center text-sm text-secondary">Aucun utilisateur visible
                                pour cette portée.</td>
                        </tr>
                    </tbody>
                </table>
            </section>-->

            <!-- Simulateur (1€ = 1 point) -->
            <section class="card-gold-premium p-6">
                <div class="flex flex-col gap-4">
                    <div>
                        <h3 class="text-xl font-semibold text-gold">Simulateur : si je verse</h3>
                        <p class="text-sm text-secondary mt-1">
                            Entrez un montant — le simulateur calcule votre score projeté et affiche la position
                            estimée dans les quatre classements principaux simultanément.
                        </p>
                    </div>

                    <!-- Input montant -->
                    <div class="text-gold mt-2">(montant actuel : <span class="font-mono">{{ authStore.user?.amount || 0
                    }}€ ({{ authStore.user?.amount || 0 }} pts)</span>)</div>
                    <div class="flex">
                        <input type="number" min="0" v-model.number="sim.amount" placeholder="Montant en euros"
                            class="input-primary rounded-lg px-4 py-2 w-40 shadow-sm border border-gray-300 focus:ring-2 focus:ring-yellow-400 focus:outline-none" />
                        <span class="ml-2 text-sm text-secondary mt-2">€</span>
                    </div>

                    <!-- Classements projetés -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
                        <div class="p-4 bg-background rounded-lg border shadow-sm">
                            <div class="text-xs text-secondary mb-1">Classement général</div>
                            <div class="text-xl font-semibold">
                                <span v-if="simulatedRanks.general">
                                    #{{ simulatedRanks.general.position }}
                                </span>
                                <span v-else>—</span>
                            </div>
                        </div>

                        <div v-if="ranks.regional" class="p-4 bg-background rounded-lg border shadow-sm">
                            <div class="text-xs text-secondary mb-1">Classement régional</div>
                            <div class="text-xl font-semibold">
                                <span v-if="simulatedRanks.regional">
                                    #{{ simulatedRanks.regional.position }}
                                </span>
                                <span v-else>—</span>
                            </div>
                        </div>

                        <div v-if="ranks.departmental" class="p-4 bg-background rounded-lg border shadow-sm">
                            <div class="text-xs text-secondary mb-1">Classement départemental</div>
                            <div class="text-xl font-semibold">
                                <span v-if="simulatedRanks.departmental">
                                    #{{ simulatedRanks.departmental.position }}
                                </span>
                                <span v-else>—</span>
                            </div>
                        </div>

                        <div v-if="ranks.city" class="p-4 bg-background rounded-lg border shadow-sm">
                            <div class="text-xs text-secondary mb-1">Classement communal</div>
                            <div class="text-xl font-semibold">
                                <span v-if="simulatedRanks.city">
                                    #{{ simulatedRanks.city.position }}
                                </span>
                                <span v-else>—</span>
                            </div>
                        </div>
                    </div>

                    <p class="mt-2 text-xs text-secondary">
                        Remarque : pour dépasser un utilisateur, il faut strictement plus que son montant. En cas
                        d’égalité,
                        celui qui a atteint ce montant en premier reste devant.
                    </p>
                </div>
            </section>

        </div>
    </div>
</template>

<script setup>
import { computed, ref, onMounted, watch } from "vue";
import { useAuthStore } from "@/stores/authStore";
import RankingService from "@/services/ranking.service";

const authStore = useAuthStore();

/* -----------------------------
   STATE
----------------------------- */

// simulateur
const sim = ref({ amount: 0 });
const quickAmounts = [5, 10, 20, 50];

const simulatedRanks = ref({
    general: null,
    regional: null,
    departmental: null,
    city: null
});

const isSimulating = ref(false);

// ranks exactement comme attendu par le template
const ranks = ref({
    general: null,
    regional: null,
    departmental: null,
    city: null
});

// top list (désactivée dans le template mais conservée)
const rankingList = ref([]);
const selectedScope = ref("general");

/* -----------------------------
   COMPUTED
----------------------------- */

const currentGeneralPosition = computed(() => ranks.value.general?.position || null);
const projectedGeneralPosition = computed(() => simulatedRanks.value.general?.position || null);

const projectedPlacesWon = computed(() => {
    if (!currentGeneralPosition.value || !projectedGeneralPosition.value) return 0;
    return Math.max(0, currentGeneralPosition.value - projectedGeneralPosition.value);
});

const rankingPitch = computed(() => {
    if (!currentGeneralPosition.value) {
        return "Ajoutez quelques points pour commencer à grimper dans le classement.";
    }

    if (!sim.value.amount) {
        return `Vous êtes actuellement #${currentGeneralPosition.value}. Simulez un montant pour visualiser votre rang après versement.`;
    }

    if (projectedPlacesWon.value > 0) {
        return `Après un versement de ${sim.value.amount}€, votre rang estimé serait #${projectedGeneralPosition.value}, soit ${projectedPlacesWon.value} place${projectedPlacesWon.value > 1 ? 's' : ''} gagnée${projectedPlacesWon.value > 1 ? 's' : ''}.`;
    }

    return `Avec ${sim.value.amount}€, votre score augmente et votre position se renforce.`;
});

const suggestedCallout = computed(() => {
    const current = currentGeneralPosition.value;
    const projected = projectedGeneralPosition.value;

    if (!current) return "Chaque euro ajouté vaut immédiatement 1 point.";
    if (projected && current > 3 && projected <= 3) return "Le podium devient accessible.";
    if (projected && current > 10 && projected <= 10) return "Le top 10 devient accessible.";
    if (projected && current > 20 && projected <= 20) return "Le top 20 se rapproche.";
    if (projected && current <= 10 && projected < current && projected <= 5) return "Vous pouvez désormais viser le top 5.";
    if (projectedPlacesWon.value >= 5) return "Belle opportunité : plusieurs places peuvent être gagnées d’un coup.";

    return "Chaque euro ajouté vaut immédiatement 1 point.";
});

const buyRankingLink = computed(() => ({
    name: "BuyRanking",
    query: sim.value.amount >= 1 ? { amount: sim.value.amount } : { amount: 10 }
}));


/* -----------------------------
   LOADERS
----------------------------- */

async function loadRanks() {
    const userId = authStore.user?.id;
    if (!userId) return;

    try {
        const all = await RankingService.getAllRanks(userId);

        ranks.value = {
            general: all.general,
            regional: all.regional,
            departmental: all.departmental,
            city: all.city
        };
    } catch (e) {
        console.error("Erreur chargement ranks :", e);
    }
}

async function loadTopList() {
    const filters = {};

    if (selectedScope.value === "regional" && ranks.value.regional) {
        filters.region_id = ranks.value.regional.regionId;
    }

    if (selectedScope.value === "departmental" && ranks.value.departmental) {
        filters.department_id = ranks.value.departmental.departmentId;
    }

    if (selectedScope.value === "city" && ranks.value.city) {
        filters.city_id = ranks.value.city.cityId;
    }

    try {
        rankingList.value = await RankingService.getTopUsers(filters);
    } catch (e) {
        console.error("Erreur chargement top list :", e);
        rankingList.value = [];
    }
}

async function refresh() {
    await loadRanks();
    await loadTopList();
}

/* -----------------------------
   SIMULATEUR
----------------------------- */

async function simulateRanks() {
    const amount = Number(sim.value.amount || 0);

    // reset si vide ou 0
    if (amount <= 0) {
        simulatedRanks.value = {
            general: null,
            regional: null,
            departmental: null,
            city: null
        };
        return;
    }

    isSimulating.value = true;

    try {
        const calls = [];

        const userId = authStore.user?.id;

        const amountSimultated = authStore.user.amount + amount;

        // général (toujours)
        calls.push(
            RankingService.getSimulatedRank({ userId, amount: amountSimultated })
        );

        // régional
        if (ranks.value.regional) {
            calls.push(
                RankingService.getSimulatedRank({
                    userId,
                    amount: amountSimultated,
                    regionId: authStore.user.region_id
                })
            );
        } else {
            calls.push(Promise.resolve(null));
        }

        // départemental
        if (ranks.value.departmental) {
            calls.push(
                RankingService.getSimulatedRank({
                    userId,
                    amount: amountSimultated,
                    departmentId: authStore.user.department_id
                })
            );
        } else {
            calls.push(Promise.resolve(null));
        }

        // communal
        if (ranks.value.city) {
            calls.push(
                RankingService.getSimulatedRank({
                    userId,
                    amount: amountSimultated,
                    cityId: authStore.user.city_id
                })
            );
        } else {
            calls.push(Promise.resolve(null));
        }

        const [general, regional, departmental, city] = await Promise.all(calls);

        simulatedRanks.value = { general, regional, departmental, city };
    } catch (e) {
        console.error("Erreur simulation classement :", e);
    } finally {
        isSimulating.value = false;
    }
}

let simTimeout = null;

watch(
    () => sim.value.amount,
    () => {
        clearTimeout(simTimeout);
        simTimeout = setTimeout(simulateRanks, 300);
    }
);


/* -----------------------------
   INIT
----------------------------- */

onMounted(async () => {
    await loadRanks();
    await loadTopList();
});
</script>



<style scoped>
/* Tout le style utilise ta config Tailwind (tailwind.config.js) et les classes utilitaires fournies. */
</style>
